import { AUDIO_PLAYER } from "~/utils/constant";

export const getSession = (key: string) => {
  if (typeof window === "undefined") return;
  return JSON.parse(sessionStorage.getItem(key) || "null");
};

export const setSession = (key: string, value: string) => {
  if (typeof window === "undefined") return;
  return sessionStorage.setItem(key, JSON.stringify(value));
};

export const removeSession = (key: string) => {
  if (typeof window === "undefined") return;
  return sessionStorage.removeItem(key);
};

export const removeAudioPlayerKeyFromSession = () => {
  keysForRemoveFromSession.forEach((item) => {
    removeSession(item);
  });
};

const keysForRemoveFromSession = [AUDIO_PLAYER.CURRENT_AUDIO, AUDIO_PLAYER.CURRENT_TIME, AUDIO_PLAYER.IS_PLAY, AUDIO_PLAYER.AUDIO_QUEUE];
